import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface SettingsState {
  autoValidation: boolean
  debugMode: boolean
  verboseLogging: boolean
  theme: 'light' | 'dark'
  notifications: {
    email: boolean
    push: boolean
  }
}

const initialState: SettingsState = {
  autoValidation: true,
  debugMode: false,
  verboseLogging: false,
  theme: 'light',
  notifications: {
    email: false,
    push: false
  }
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateSetting(state, action: PayloadAction<{ key: string; value: any }>) {
      const { key, value } = action.payload
      if (key in state) {
        (state as any)[key] = value
      }
    },
    
    toggleAutoValidation(state) {
      state.autoValidation = !state.autoValidation
    },
    
    toggleDebugMode(state) {
      state.debugMode = !state.debugMode
    },
    
    toggleVerboseLogging(state) {
      state.verboseLogging = !state.verboseLogging
    },
    
    setTheme(state, action: PayloadAction<'light' | 'dark'>) {
      state.theme = action.payload
    },
    
    updateNotificationSettings(state, action: PayloadAction<Partial<SettingsState['notifications']>>) {
      Object.assign(state.notifications, action.payload)
    },
    
    resetSettings(state) {
      Object.assign(state, initialState)
    }
  }
})

export const {
  updateSetting,
  toggleAutoValidation,
  toggleDebugMode,
  toggleVerboseLogging,
  setTheme,
  updateNotificationSettings,
  resetSettings
} = settingsSlice.actions

export default settingsSlice.reducer
